module.exports = __webpack_public_path__ + "berlin-e1d948b39c41a99dd028303bfa9be8ce.bundle.jpg";